export const MAX_MOBILE_WIDTH = 949;
export const MIN_DESKTOP_WIDTH = 950;
